module.exports = __webpack_public_path__ + "static/media/logoLynkbooster.16c6b87b.png";